import type { Anime } from '@/types';

export const animeList: Anime[] = [
  {
    id: 'xinghai-lvren',
    title: '星海旅人',
    cover: 'https://readdy.ai/api/search-image?query=Vibrant%20anime%20poster%20art%20of%20a%20young%20space%20traveler%20girl%20in%20a%20sleek%20silver%20suit%20floating%20before%20a%20glowing%20purple%20nebula%2C%20clean%20gradient%20background%2C%20high%20detail%20illustration&width=600&height=800&seq=anime-cover-01&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Cinematic%20wide%20anime%20scene%20of%20a%20lone%20space%20traveler%20sailing%20past%20giant%20glowing%20planets%20and%20a%20purple%20nebula%2C%20dramatic%20lighting%2C%20detailed%20illustration&width=1200&height=675&seq=anime-banner-01&orientation=landscape',
    summary: '穿越星海的少女，寻找失落的故乡坐标。',
    description: '在人类文明散落于群星的年代，少女舰长诺雅驾驶着老旧飞船「鲸落号」，沿着母亲留下的星图碎片，寻找传说中已被遗忘的母星。旅途中她结识了形形色色的伙伴，也逐渐揭开星海旅人背后尘封的秘密。',
    type: '科幻',
    region: '日本',
    year: 2024,
    status: '连载中',
    rating: 9.2,
    tags: ['科幻', '冒险', '太空', '成长'],
    views: 1286000,
    favorites: 86400,
    episodes: 12,
    updatedAt: '2026-09-28',
  },
  {
    id: 'jianying-changge',
    title: '剑影长歌',
    cover: 'https://readdy.ai/api/search-image?query=Vibrant%20anime%20poster%20of%20a%20young%20swordsman%20in%20flowing%20red%20robes%20holding%20a%20glowing%20blade%2C%20dynamic%20pose%2C%20warm%20sunset%20background%2C%20high%20detail%20illustration&width=600&height=800&seq=anime-cover-02&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Epic%20wide%20anime%20battle%20scene%20of%20two%20swordsmen%20clashing%20with%20glowing%20blades%20on%20a%20cliff%20at%20sunset%2C%20embers%20in%20the%20air%2C%20dramatic%20illustration&width=1200&height=675&seq=anime-banner-02&orientation=landscape',
    summary: '乱世之中，少年以一剑长歌问天下。',
    description: '王朝倾颓，江湖动荡。出身寒门的少年剑客云长歌，凭一柄残剑踏入风云诡谲的江湖。他要查清师门覆灭的真相，也在一次次生死决斗中，重新定义了何为侠义。',
    type: '热血',
    region: '国产',
    year: 2024,
    status: '连载中',
    rating: 8.9,
    tags: ['热血', '武侠', '古风', '战斗'],
    views: 1523000,
    favorites: 91200,
    episodes: 16,
    updatedAt: '2026-10-02',
  },
  {
    id: 'yingse-huiyi',
    title: '樱色回忆',
    cover: 'https://readdy.ai/api/search-image?query=Soft%20anime%20poster%20of%20a%20high%20school%20girl%20under%20blooming%20cherry%20blossom%20trees%20in%20spring%2C%20pastel%20pink%20palette%2C%20romantic%20atmosphere%2C%20detailed%20illustration&width=600&height=800&seq=anime-cover-03&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Wide%20romantic%20anime%20scene%20of%20two%20students%20walking%20along%20a%20cherry%20blossom%20avenue%20in%20spring%20dusk%2C%20soft%20pastel%20lighting%2C%20illustration&width=1200&height=675&seq=anime-banner-03&orientation=landscape',
    summary: '那一年樱花落下的速度，是心动的速度。',
    description: '转学来到海边的城镇，少女美咲遇见了总在天台上画画的少年。一段关于青春、约定与告别的故事，在四季轮转的樱花树下缓缓展开。',
    type: '恋爱',
    region: '日本',
    year: 2023,
    status: '已完结',
    rating: 8.5,
    tags: ['恋爱', '青春', '治愈', '校园'],
    views: 986000,
    favorites: 72300,
    episodes: 12,
    updatedAt: '2026-06-15',
  },
  {
    id: 'longyuan-ji',
    title: '龙渊记',
    cover: 'https://readdy.ai/api/search-image?query=Fantasy%20anime%20poster%20of%20a%20young%20dragon%20rider%20standing%20before%20a%20colossal%20glowing%20blue%20dragon%2C%20epic%20mountain%20background%2C%20high%20detail%20illustration&width=600&height=800&seq=anime-cover-04&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Epic%20wide%20fantasy%20anime%20scene%20of%20a%20giant%20blue%20dragon%20flying%20over%20misty%20ancient%20mountains%20at%20dawn%2C%20cinematic%20illustration&width=1200&height=675&seq=anime-banner-04&orientation=landscape',
    summary: '龙魂觉醒，少年背负起整个大陆的命运。',
    description: '远古龙族早已陨落，只余传说。边陲少年林渊意外唤醒沉睡的龙魂，被卷入人族与妖族延续千年的纷争之中。为了守护家园，他必须掌握龙渊之力，直面宿命。',
    type: '玄幻',
    region: '国产',
    year: 2024,
    status: '连载中',
    rating: 9.0,
    tags: ['玄幻', '热血', '冒险', '国漫'],
    views: 1770000,
    favorites: 103500,
    episodes: 20,
    updatedAt: '2026-10-05',
  },
  {
    id: 'yekong-zhicheng',
    title: '夜空之城',
    cover: 'https://readdy.ai/api/search-image?query=Dreamy%20anime%20poster%20of%20a%20floating%20city%20lit%20by%20crystal%20lanterns%20above%20a%20sea%20of%20clouds%20at%20night%2C%20deep%20indigo%20palette%2C%20detailed%20illustration&width=600&height=800&seq=anime-cover-05&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Wide%20fantasy%20anime%20scene%20of%20a%20floating%20city%20among%20stars%20and%20clouds%20at%20night%2C%20glowing%20lanterns%2C%20dreamy%20illustration&width=1200&height=675&seq=anime-banner-05&orientation=landscape',
    summary: '漂浮于夜空的城市，藏着被遗忘的魔法。',
    description: '据说每当流星划过，夜空之城便会短暂显现。少女阿澈为了寻找失踪的姐姐，踏上了通往浮空之城的旅程，在那里她遇见了守护城市的最后一位星象师。',
    type: '奇幻',
    region: '日本',
    year: 2024,
    status: '已完结',
    rating: 8.8,
    tags: ['奇幻', '冒险', '治愈'],
    views: 812000,
    favorites: 64100,
    episodes: 12,
    updatedAt: '2026-07-20',
  },
  {
    id: 'gangtie-jiyuan',
    title: '钢铁纪元',
    cover: 'https://readdy.ai/api/search-image?query=Anime%20poster%20of%20a%20giant%20humanoid%20mecha%20with%20glowing%20orange%20core%20in%20a%20ruined%20city%2C%20dramatic%20lighting%2C%20high%20detail%20illustration&width=600&height=800&seq=anime-cover-06&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Wide%20sci-fi%20anime%20scene%20of%20a%20giant%20mecha%20standing%20in%20a%20ruined%20futuristic%20city%20at%20dusk%2C%20smoke%20and%20glowing%20lights%2C%20cinematic%20illustration&width=1200&height=675&seq=anime-banner-06&orientation=landscape',
    summary: '当钢铁巨神苏醒，人类迎来最后的纪元。',
    description: '大战之后，人类退守于巨型要塞都市。少年驾驶员时雨被选为新一代「钢铁纪元」的操控者，却发现机甲核心中封存着一段不该被记起的记忆。',
    type: '机甲',
    region: '日本',
    year: 2023,
    status: '已完结',
    rating: 9.1,
    tags: ['机甲', '科幻', '战斗', '燃'],
    views: 1432000,
    favorites: 95700,
    episodes: 24,
    updatedAt: '2026-05-30',
  },
  {
    id: 'changan-huanye',
    title: '长安幻夜',
    cover: 'https://readdy.ai/api/search-image?query=Anime%20poster%20of%20an%20elegant%20girl%20in%20traditional%20Tang%20dynasty%20dress%20standing%20in%20lantern-lit%20ancient%20city%20at%20night%2C%20warm%20golden%20palette%2C%20detailed%20illustration&width=600&height=800&seq=anime-cover-07&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Wide%20anime%20scene%20of%20the%20ancient%20city%20Changan%20at%20night%20with%20thousands%20of%20lanterns%20and%20pagodas%2C%20warm%20golden%20light%2C%20detailed%20illustration&width=1200&height=675&seq=anime-banner-07&orientation=landscape',
    summary: '灯火长安，幻夜之中妖与人共存。',
    description: '盛唐长安，白日是人间繁华，入夜则百鬼夜行。擅长绘符的少女苏暖意外闯入了人妖交界的「幻夜」，为守护两界的平衡，她与冷面捉妖师一同踏上了未知的旅途。',
    type: '古风',
    region: '国产',
    year: 2024,
    status: '连载中',
    rating: 8.7,
    tags: ['古风', '奇幻', '国漫'],
    views: 1096000,
    favorites: 78800,
    episodes: 14,
    updatedAt: '2026-09-30',
  },
  {
    id: 'shenhai-huixiang',
    title: '深海回响',
    cover: 'https://readdy.ai/api/search-image?query=Mysterious%20anime%20poster%20of%20a%20girl%20in%20a%20diving%20suit%20surrounded%20by%20glowing%20deep%20sea%20creatures%2C%20teal%20and%20dark%20blue%20palette%2C%20detailed%20illustration&width=600&height=800&seq=anime-cover-08&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Wide%20suspenseful%20anime%20scene%20of%20a%20solitary%20submarine%20descending%20into%20a%20glowing%20deep%20sea%20trench%2C%20teal%20and%20dark%20blue%20tones%2C%20illustration&width=1200&height=675&seq=anime-banner-08&orientation=landscape',
    summary: '深海之下，回响着一个不该被听见的声音。',
    description: '一支深海考察队在海底听到了无法解释的低语。随着调查深入，被称为「回响」的现象开始影响每个队员的记忆。真相究竟潜藏在多深的地方？',
    type: '悬疑',
    region: '日本',
    year: 2024,
    status: '连载中',
    rating: 9.3,
    tags: ['悬疑', '科幻', '剧情'],
    views: 1654000,
    favorites: 112300,
    episodes: 13,
    updatedAt: '2026-10-08',
  },
  {
    id: 'lingneng-shaonian',
    title: '灵能少年',
    cover: 'https://readdy.ai/api/search-image?query=Dynamic%20anime%20poster%20of%20a%20teenage%20boy%20with%20glowing%20energy%20aura%20around%20his%20hands%2C%20electric%20blue%20sparks%2C%20urban%20background%2C%20detailed%20illustration&width=600&height=800&seq=anime-cover-09&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Action%20anime%20scene%20of%20a%20teenager%20unleashing%20a%20glowing%20energy%20blast%20in%20a%20city%20street%2C%20blue%20sparks%2C%20dynamic%20illustration&width=1200&height=675&seq=anime-banner-09&orientation=landscape',
    summary: '平凡少年觉醒超能力，校园变成战场。',
    description: '普通高中生平野彻在一次意外后觉醒了灵能。为了保护身边的人，他加入秘密组织，与同样拥有能力却立场相反的同学们展开对抗。',
    type: '热血',
    region: '日本',
    year: 2022,
    status: '已完结',
    rating: 8.6,
    tags: ['热血', '超能力', '校园', '战斗'],
    views: 1210000,
    favorites: 80600,
    episodes: 25,
    updatedAt: '2026-04-18',
  },
  {
    id: 'shanhai-shitang',
    title: '山海食堂',
    cover: 'https://readdy.ai/api/search-image?query=Cozy%20anime%20poster%20of%20a%20small%20warm%20restaurant%20with%20steaming%20dishes%20and%20cute%20mythical%20creature%20guests%2C%20warm%20amber%20palette%2C%20detailed%20illustration&width=600&height=800&seq=anime-cover-10&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Cozy%20anime%20scene%20of%20a%20warm%20little%20restaurant%20interior%20with%20steaming%20food%20and%20friendly%20mythical%20beasts%2C%20warm%20amber%20lighting%2C%20illustration&width=1200&height=675&seq=anime-banner-10&orientation=landscape',
    summary: '山海之间，有一间只招待妖怪的深夜食堂。',
    description: '在人与妖的交界处，有一间不起眼的小食堂。店主阿禾用一道道家常菜，收留并治愈着每一位到访的妖怪客人，也在他们的故事里，找到了自己留下的理由。',
    type: '治愈',
    region: '国产',
    year: 2024,
    status: '连载中',
    rating: 8.4,
    tags: ['治愈', '日常', '国漫', '美食'],
    views: 742000,
    favorites: 58900,
    episodes: 12,
    updatedAt: '2026-09-22',
  },
  {
    id: 'lingdian-zhentan',
    title: '零点侦探',
    cover: 'https://readdy.ai/api/search-image?query=Stylish%20anime%20poster%20of%20a%20young%20detective%20in%20a%20long%20coat%20holding%20a%20magnifying%20glass%20under%20rainy%20neon%20city%20lights%2C%20noir%20mood%2C%20detailed%20illustration&width=600&height=800&seq=anime-cover-11&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Moody%20noir%20anime%20scene%20of%20a%20rainy%20neon-lit%20city%20street%20at%20midnight%20with%20a%20lone%20detective%20silhouette%2C%20cinematic%20illustration&width=1200&height=675&seq=anime-banner-11&orientation=landscape',
    summary: '每一个午夜，都有一桩无人能解的谜。',
    description: '被称为「零点侦探」的九条莲只在午夜之后接受委托。越是不合常理的案件，越能勾起他的兴趣。可当他接手一桩跨越十年的悬案时，才发现自己才是谜题的一部分。',
    type: '推理',
    region: '日本',
    year: 2023,
    status: '已完结',
    rating: 9.0,
    tags: ['推理', '悬疑', '剧情'],
    views: 1135000,
    favorites: 84200,
    episodes: 12,
    updatedAt: '2026-06-02',
  },
  {
    id: 'yunduan-wangguo',
    title: '云端王国',
    cover: 'https://readdy.ai/api/search-image?query=Bright%20anime%20poster%20of%20a%20cheerful%20princess%20standing%20on%20a%20cloud%20kingdom%20with%20rainbow%20bridges%2C%20colorful%20fantasy%20background%2C%20detailed%20illustration&width=600&height=800&seq=anime-cover-12&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Colorful%20fantasy%20anime%20scene%20of%20a%20cloud%20kingdom%20with%20rainbow%20bridges%20and%20flying%20ships%2C%20bright%20cheerful%20illustration&width=1200&height=675&seq=anime-banner-12&orientation=landscape',
    summary: '在云朵之上的王国，公主偷偷溜去了人间。',
    description: '云端王国的公主从小被教导要端庄守礼，可她最向往的却是云层之下的人间烟火。一次意外的坠落，让她遇见了经营热气球生意的少年，两个世界就此交汇。',
    type: '奇幻',
    region: '国产',
    year: 2024,
    status: '连载中',
    rating: 8.3,
    tags: ['奇幻', '冒险', '治愈'],
    views: 668000,
    favorites: 47300,
    episodes: 10,
    updatedAt: '2026-09-12',
  },
  {
    id: 'nifeng-paozhe',
    title: '逆风跑者',
    cover: 'https://readdy.ai/api/search-image?query=Energetic%20anime%20poster%20of%20a%20teenage%20runner%20sprinting%20on%20a%20track%20at%20sunrise%2C%20motion%20blur%2C%20orange%20sky%2C%20detailed%20illustration&width=600&height=800&seq=anime-cover-13&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Dynamic%20anime%20scene%20of%20teenagers%20running%20a%20relay%20race%20on%20a%20track%20at%20sunrise%2C%20orange%20sky%2C%20energetic%20illustration&width=1200&height=675&seq=anime-banner-13&orientation=landscape',
    summary: '只要还在奔跑，就没有到不了的终点。',
    description: '因伤被迫放弃短跑的少年大地，转学后加入了一支濒临解散的接力队。在一次次逆风的训练中，他找回了跑步的意义，也带着队友重新站上了赛场。',
    type: '运动',
    region: '日本',
    year: 2024,
    status: '连载中',
    rating: 8.9,
    tags: ['运动', '热血', '青春', '励志'],
    views: 934000,
    favorites: 69800,
    episodes: 15,
    updatedAt: '2026-10-01',
  },
  {
    id: 'linglan-xiaozhen',
    title: '铃兰小镇',
    cover: 'https://readdy.ai/api/search-image?query=Peaceful%20anime%20poster%20of%20a%20small%20countryside%20town%20with%20flower%20fields%20and%20a%20girl%20on%20a%20bicycle%2C%20soft%20green%20and%20cream%20palette%2C%20detailed%20illustration&width=600&height=800&seq=anime-cover-14&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Peaceful%20anime%20scene%20of%20a%20small%20countryside%20town%20with%20flower%20fields%20and%20wooden%20houses%20in%20soft%20morning%20light%2C%20illustration&width=1200&height=675&seq=anime-banner-14&orientation=landscape',
    summary: '慢下来的小镇生活，藏着最温柔的日常。',
    description: '为了照顾外婆，少女香菜搬回了童年记忆里的铃兰小镇。在这里，四季更替格外清晰，邻里之间的温情、邻家少女的友情，让她的生活慢慢有了新的颜色。',
    type: '日常',
    region: '日本',
    year: 2023,
    status: '已完结',
    rating: 8.2,
    tags: ['日常', '治愈', '田园'],
    views: 578000,
    favorites: 43200,
    episodes: 12,
    updatedAt: '2026-03-25',
  },
  {
    id: 'fentian-zhanji',
    title: '焚天战纪',
    cover: 'https://readdy.ai/api/search-image?query=Fiery%20anime%20poster%20of%20a%20young%20warrior%20surrounded%20by%20flames%20holding%20a%20blazing%20sword%2C%20red%20and%20orange%20palette%2C%20high%20detail%20illustration&width=600&height=800&seq=anime-cover-15&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Epic%20anime%20scene%20of%20a%20warrior%20unleashing%20a%20towering%20flame%20in%20a%20burning%20battlefield%2C%20red%20and%20orange%20tones%2C%20cinematic%20illustration&width=1200&height=675&seq=anime-banner-15&orientation=landscape',
    summary: '焚尽旧世，燃起新天。',
    description: '在灵力枯竭的末法时代，少年炎戈觉醒了上古失传的焚天血脉。面对垄断灵力的豪门与蠢蠢欲动的异族，他要用这团火，烧出一条属于自己的路。',
    type: '热血',
    region: '国产',
    year: 2024,
    status: '连载中',
    rating: 8.8,
    tags: ['热血', '玄幻', '国漫', '战斗'],
    views: 1345000,
    favorites: 88900,
    episodes: 18,
    updatedAt: '2026-10-06',
  },
  {
    id: 'shiguang-xinjian',
    title: '时光信笺',
    cover: 'https://readdy.ai/api/search-image?query=Romantic%20anime%20poster%20of%20a%20girl%20holding%20a%20glowing%20letter%20in%20an%20old%20library%2C%20warm%20sepia%20and%20rose%20palette%2C%20detailed%20illustration&width=600&height=800&seq=anime-cover-16&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Warm%20romantic%20anime%20scene%20of%20a%20sunlit%20old%20library%20with%20floating%20glowing%20letters%2C%20sepia%20and%20rose%20lighting%2C%20illustration&width=1200&height=675&seq=anime-banner-16&orientation=landscape',
    summary: '寄往过去的一封信，改写了两个人的未来。',
    description: '文学社的少女律在一次整理旧书时，发现了一个能将信寄往过去的信箱。她试着写下第一封信，却意外与十年前的某个少年建立起跨越时空的联系。',
    type: '恋爱',
    region: '日本',
    year: 2024,
    status: '连载中',
    rating: 9.0,
    tags: ['恋爱', '奇幻', '治愈', '校园'],
    views: 1043000,
    favorites: 77500,
    episodes: 12,
    updatedAt: '2026-09-27',
  },
  {
    id: 'huangye-xingzhe',
    title: '荒野行者',
    cover: 'https://readdy.ai/api/search-image?query=Adventure%20anime%20poster%20of%20a%20lone%20traveler%20in%20a%20tattered%20cloak%20walking%20through%20a%20vast%20desert%20canyon%2C%20warm%20earth%20tones%2C%20detailed%20illustration&width=600&height=800&seq=anime-cover-17&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Wide%20adventure%20anime%20scene%20of%20a%20lone%20traveler%20crossing%20a%20vast%20desert%20canyon%20at%20golden%20hour%2C%20cinematic%20illustration&width=1200&height=675&seq=anime-banner-17&orientation=landscape',
    summary: '没有地图的旅途，才叫真正的冒险。',
    description: '文明崩塌后的荒原上，独行者凯带着一张残缺的旧地图，寻找传说中绿意尚存的「应许之地」。沿途的废墟、幸存者与怪物的故事，拼凑出世界曾经的样貌。',
    type: '冒险',
    region: '欧美',
    year: 2023,
    status: '已完结',
    rating: 8.5,
    tags: ['冒险', '末世', '剧情'],
    views: 689000,
    favorites: 51200,
    episodes: 13,
    updatedAt: '2026-05-12',
  },
  {
    id: 'huanjing-wuyu',
    title: '幻镜物语',
    cover: 'https://readdy.ai/api/search-image?query=Surreal%20anime%20poster%20of%20a%20girl%20stepping%20through%20a%20giant%20magical%20mirror%20into%20a%20dreamlike%20world%2C%20iridescent%20colors%2C%20detailed%20illustration&width=600&height=800&seq=anime-cover-18&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Surreal%20anime%20scene%20of%20a%20dreamlike%20world%20made%20of%20floating%20mirrors%20and%20iridescent%20light%2C%20magical%20atmosphere%2C%20illustration&width=1200&height=675&seq=anime-banner-18&orientation=landscape',
    summary: '镜中的世界，映出的是另一个自己。',
    description: '少女镜音拥有能进入镜中世界的能力。那里有她从未见过的奇景，也有不愿面对的自己。每一次穿越，都是一次自我和解的旅程。',
    type: '奇幻',
    region: '日本',
    year: 2022,
    status: '已完结',
    rating: 8.7,
    tags: ['奇幻', '治愈', '剧情'],
    views: 623000,
    favorites: 49800,
    episodes: 12,
    updatedAt: '2026-02-20',
  },
  {
    id: 'mose-jianghu',
    title: '墨色江湖',
    cover: 'https://readdy.ai/api/search-image?query=Ink%20wash%20anime%20poster%20of%20a%20martial%20artist%20in%20black%20robes%20with%20a%20calligraphy%20brush%20sword%2C%20monochrome%20ink%20style%20with%20red%20seal%20accents%2C%20detailed%20illustration&width=600&height=800&seq=anime-cover-19&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Ink%20wash%20anime%20scene%20of%20a%20swordsman%20fighting%20among%20giant%20floating%20calligraphy%20strokes%2C%20monochrome%20ink%20painting%20style%2C%20illustration&width=1200&height=675&seq=anime-banner-19&orientation=landscape',
    summary: '以笔墨为剑，写尽江湖恩怨。',
    description: '在武功以「字」为形的江湖里，擅长书法的少年墨子墨，凭一手绝世墨法行走天下。一卷神秘的字帖，牵出了一段被江湖刻意抹去的往事。',
    type: '武侠',
    region: '国产',
    year: 2024,
    status: '连载中',
    rating: 8.6,
    tags: ['武侠', '古风', '国漫'],
    views: 856000,
    favorites: 62300,
    episodes: 14,
    updatedAt: '2026-09-18',
  },
  {
    id: 'yuzhou-kafeiting',
    title: '宇宙咖啡厅',
    cover: 'https://readdy.ai/api/search-image?query=Charming%20sci-fi%20anime%20poster%20of%20a%20cozy%20space%20station%20cafe%20with%20alien%20customers%20and%20a%20starry%20window%2C%20teal%20and%20violet%20palette%2C%20detailed%20illustration&width=600&height=800&seq=anime-cover-20&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Cozy%20sci-fi%20anime%20scene%20of%20a%20small%20cafe%20on%20a%20space%20station%20with%20a%20window%20overlooking%20a%20galaxy%2C%20teal%20and%20violet%20lighting%2C%20illustration&width=1200&height=675&seq=anime-banner-20&orientation=landscape',
    summary: '银河系最偏僻的角落，有一间咖啡厅。',
    description: '在星际航线的尽头，有一间总被导航忽略的咖啡厅。店主招待着往来的星际旅人，用一杯杯特调，聆听着宇宙中那些无人知晓的故事。',
    type: '科幻',
    region: '日本',
    year: 2024,
    status: '连载中',
    rating: 8.9,
    tags: ['科幻', '治愈', '日常'],
    views: 758000,
    favorites: 56700,
    episodes: 12,
    updatedAt: '2026-09-25',
  },
  {
    id: 'huangdao-qiusheng',
    title: '荒岛求生记',
    cover: 'https://readdy.ai/api/search-image?query=Adventure%20anime%20poster%20of%20a%20small%20group%20of%20survivors%20on%20a%20tropical%20island%20beach%20with%20a%20signal%20fire%2C%20bright%20turquoise%20and%20sand%20tones%2C%20detailed%20illustration&width=600&height=800&seq=anime-cover-21&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Wide%20adventure%20anime%20scene%20of%20survivors%20on%20a%20tropical%20island%20at%20sunset%20with%20a%20signal%20fire%20on%20the%20beach%2C%20turquoise%20and%20golden%20tones%2C%20illustration&width=1200&height=675&seq=anime-banner-21&orientation=landscape',
    summary: '一场海难，把七个陌生人困在了荒岛。',
    description: '豪华游轮触礁沉没，七名背景各异的幸存者漂流到一座无人岛。在资源有限、信任脆弱的环境里，他们必须学会合作，才能等到救援的那一天。',
    type: '冒险',
    region: '欧美',
    year: 2024,
    status: '已完结',
    rating: 0,
    tags: ['冒险', '生存', '剧情'],
    views: 512000,
    favorites: 38600,
    episodes: 10,
    updatedAt: '2026-08-14',
  },
  {
    id: 'xinggui-biannianshi',
    title: '星轨编年史',
    cover: 'https://readdy.ai/api/search-image?query=Grand%20fantasy%20anime%20poster%20of%20a%20mage%20holding%20a%20glowing%20astrolabe%20surrounded%20by%20constellations%2C%20deep%20violet%20and%20gold%20palette%2C%20detailed%20illustration&width=600&height=800&seq=anime-cover-22&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Epic%20fantasy%20anime%20scene%20of%20a%20mage%20channeling%20constellations%20in%20the%20night%20sky%20above%20an%20ancient%20tower%2C%20deep%20violet%20and%20gold%20illustration&width=1200&height=675&seq=anime-banner-22&orientation=landscape',
    summary: '星辰的轨迹，书写着世界的命运。',
    description: '在以星象推演魔法的世界，少女星术师伊莱尔发现星轨正在发生前所未有的偏移。为了阻止预言的灾厄，她踏上旅途，去寻找能改写星轨的传说之钥。',
    type: '奇幻',
    region: '日本',
    year: 2023,
    status: '已完结',
    rating: 9.2,
    tags: ['奇幻', '魔法', '史诗'],
    views: 1389000,
    favorites: 96400,
    episodes: 24,
    updatedAt: '2026-06-28',
  },
  {
    id: 'shaonian-yulingshi',
    title: '少年御灵师',
    cover: 'https://readdy.ai/api/search-image?query=Anime%20poster%20of%20a%20young%20spirit%20master%20with%20glowing%20talismans%20and%20a%20friendly%20fox%20spirit%20beside%20him%2C%20purple%20and%20gold%20palette%2C%20detailed%20illustration&width=600&height=800&seq=anime-cover-23&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Anime%20scene%20of%20a%20young%20spirit%20master%20summoning%20glowing%20spirits%20under%20a%20full%20moon%2C%20purple%20and%20gold%20tones%2C%20dynamic%20illustration&width=1200&height=675&seq=anime-banner-23&orientation=landscape',
    summary: '御灵一脉的最后传人，踏上了收妖之路。',
    description: '在现代都市的暗面，妖怪从未消失。少年叶其作为御灵师一脉的最后传人，与灵狐伙伴一起，守护着人与妖之间脆弱的界限，也寻找着师门消失的真相。',
    type: '玄幻',
    region: '国产',
    year: 2024,
    status: '连载中',
    rating: 8.5,
    tags: ['玄幻', '国漫', '战斗', '都市'],
    views: 903000,
    favorites: 65200,
    episodes: 16,
    updatedAt: '2026-10-03',
  },
  {
    id: 'muse-lieche',
    title: '暮色列车',
    cover: 'https://readdy.ai/api/search-image?query=Melancholic%20anime%20poster%20of%20an%20old%20train%20traveling%20through%20a%20quiet%20countryside%20at%20dusk%2C%20girl%20looking%20out%20the%20window%2C%20amber%20and%20indigo%20palette%2C%20detailed%20illustration&width=600&height=800&seq=anime-cover-24&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Melancholic%20anime%20scene%20of%20a%20lone%20train%20crossing%20a%20countryside%20at%20dusk%20under%20a%20purple%20sky%2C%20warm%20window%20lights%2C%20illustration&width=1200&height=675&seq=anime-banner-24&orientation=landscape',
    summary: '末班列车，载着每个乘客未说出口的告别。',
    description: '传闻在暮色降临后，有一班只在深夜运行的神秘列车，专为那些心里还留着遗憾的人而开。少女澄在站台等待多年，只为赶上那一班开往过去的车。',
    type: '治愈',
    region: '日本',
    year: 2024,
    status: '连载中',
    rating: 9.1,
    tags: ['治愈', '剧情', '奇幻'],
    views: 1108000,
    favorites: 83200,
    episodes: 11,
    updatedAt: '2026-10-10',
  },
];